import { render } from "./metricBox.vue?vue&type=template&id=d8393bba&scoped=true"
import script from "./metricBox.vue?vue&type=script&lang=js"
export * from "./metricBox.vue?vue&type=script&lang=js"

import "./metricBox.vue?vue&type=style&index=0&id=d8393bba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8393bba"]])

export default __exports__